
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

interface AddNewDialogProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  disabled?: boolean;
}

const AddNewDialog: React.FC<AddNewDialogProps> = ({
  title,
  value,
  onChange,
  onAdd,
  disabled
}) => {
  const [open, setOpen] = useState(false);

  const handleAdd = () => {
    onAdd();
    setOpen(false);
    onChange(''); // Clear the input after adding
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="icon">+</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New {title}</DialogTitle>
        </DialogHeader>
        <div className="flex gap-2">
          <Input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={`${title} name`}
          />
          <Button 
            onClick={handleAdd}
            disabled={!value || disabled}
          >
            Add
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddNewDialog;

